// MARK: NPM Modules
import React, { useState, useEffect } from "react";
import { graphql } from "gatsby";
// MARK: Redux
import store from "reduxFunctionality/index";
import { Provider } from "react-redux";
// MARK: Types
import Props from "types/pages/about/outcomes/props";
// MARK: Components
import Layout from "layouts/about/outcomes";
import Styleguide from "globals/styleguide";
import NavigationBar from "globals/navigationBar";
import Footer from "globals/footer";
import GlobalStyles from "utils/styleguide/documentBase";
// MARK: Functionality
import MetaData from "utils/seo/metaData";
import ScrollToAnchor from "utils/common/scrollToHash";
import InitializeGoogleAnalytics from "utils/google-analytics";
import getSEOFromData from "utils/seo/seoFromData";
// MARK: Fragments
// @ts-ignore
import { AuthorFragment, MultilineHeadlineFragment } from "src/graphql";
// MARK: React Component
const OutcomesPage = ({ pageContext, data }: Props) => {
  // MARK: State Variables
  const [styleguideAvailable, setStyleguideAvailable] =
    useState<boolean>(false);
  // MARK: Use Effects
  useEffect(() => {
    InitializeGoogleAnalytics();
  }, []);
  useEffect(() => {
    ScrollToAnchor();
  }, [styleguideAvailable]);
  // MARK: Variables
  const { styleguide, navigationBar, footer } = pageContext;

  // Functionality
  const renderScene = () => {
    var scene: any = [];
    scene.push(<NavigationBar key="navigation-bar" data={navigationBar} />);
    scene.push(
      <Layout key="layout" layout={data.craftApiAboutOutcomesEntry} />
    );
    scene.push(
      <Footer key="footer" data={footer} navigationBarData={navigationBar} />
    );
    return scene;
  };

  // MARK: Render
  return (
    <Provider store={store}>
      <GlobalStyles styleguide={styleguide} />
      <MetaData seo={getSEOFromData(data.craftApiAboutOutcomesEntry.uri, data.craftApiAboutOutcomesEntry)} />
      <Styleguide
        styleguide={styleguide}
        onStyleguideUpdate={() => {
          if (!styleguideAvailable) {
            setStyleguideAvailable(true);
          }
        }}
      />
      {renderScene()}
    </Provider>
  );
};

export default OutcomesPage;

export const query = graphql`
  query IndividualAboutOutcomesEntryQuery($id: ID) {
    craftApiAboutOutcomesEntry(remoteId: { eq: $id }) {
      uri
      dateCreated
      dateUpdated
      metaTitle
      metaDescription
      author {
        ...AuthorFragment
      }
      seoImage {
        ... on CraftAPI_seo_seoImage_Entry {
          seoImageAsset {
            url
            width
            height
          }
        }
      }
      title
      multilineHeadline {
        ...MultilineHeadlineFragment
      }
      description
      outcomesGrid {
        typeHandle
        ...WorkHeroOutcomeFragment
        ...WorkTextOutcomeFragment
      }
    }
  }
`;
